export default __webpack_public_path__ + "static/media/Wrist-straps of the Blood God.a4dad882.jpg";